var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-snackbar',{attrs:{"top":"","value":_vm.showToast,"color":_vm.type,"timeout":-1},on:{"input":_vm.hideToast}},[_c('span',{domProps:{"innerHTML":_vm._s(_vm.message)}}),_c('v-icon',{on:{"click":_vm.hideToast}},[_vm._v("close")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }